import { useMemo } from 'react'
import { collection, query, where } from 'firebase/firestore'
import type { Query } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { useFirestoreCollection } from './useFirestore'
import type { Event } from '../types'

// Events that point back at `parentEventId` — a festival's afterparties. Drafts
// are dropped the same way useEvents does, so an unpublished after never leaks
// onto the festival page before it's reviewed.
export function useChildEvents(parentEventId: string | null) {
  const q = useMemo(
    () =>
      parentEventId
        ? (query(collection(db, 'events'), where('parentEventId', '==', parentEventId)) as Query<Event>)
        : null,
    [parentEventId],
  )
  const { data, loading, error } = useFirestoreCollection<Event>(q)
  const events = useMemo(
    () =>
      data
        .filter(e => e.published !== false)
        .sort((a, b) => a.startDate.localeCompare(b.startDate)),
    [data],
  )
  return { events, loading, error }
}
